import { render, staticRenderFns } from "./PracticeDrills.vue?vue&type=template&id=70cb9938&scoped=true&"
import script from "./PracticeDrills.vue?vue&type=script&lang=js&"
export * from "./PracticeDrills.vue?vue&type=script&lang=js&"
import style0 from "./PracticeDrills.vue?vue&type=style&index=0&id=70cb9938&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70cb9938",
  null
  
)

export default component.exports